<ng-container *transloco="let t;">
    <div class="form-group px-1 mt-1">
        <div class="custom-control custom-checkbox">
        <input
            type="checkbox"
            [(ngModel)]="isLocked"
            class="custom-control-input"
            id="lock_field"
            (change)="onChange($event)"
        />
        <label class="custom-control-label" for="lock_field">{{t("Field settings Lock the field (general) - Lock")}}</label>
        </div>
    </div>
</ng-container>